import BlackWhiteIcon from '../Icons/BlackWhiteIcon';
import { useLayoutContext } from '../Layout/LayoutProvider/LayoutContext';
import { AccessibilityOption } from './AccessibilityButton';

const GrayscaleOption = () => {
  const {
    layout: { setIsGrayScaled, isGrayScaled },
  } = useLayoutContext();

  function toggleGrayscale() {
    if (setIsGrayScaled) {
      setIsGrayScaled(!isGrayScaled);
    }
  }

  return (
    <AccessibilityOption
      name={'Escala de grises'}
      icon={<BlackWhiteIcon className="h-3 w-3 " />}
      onClick={() => toggleGrayscale()}
    />
  );
};

export default GrayscaleOption;
